import DropdownButton, { DropdownButtonProps } from '@lyra/core/components/DropdownButton'
import { ArrowLeftRight } from '@lyra/core/components/Icon'
import { SubaccountData } from '@lyra/web/constants/subaccount'
import useSubaccount from '@lyra/web/hooks/useSubaccount'
import React from 'react'

import SubaccountsDropdownItems from './SubaccountsDropdownItems'

type Props = {
  subaccountId: number
  onSelect: (subaccountId: number) => void
  isSmOnly?: boolean
  ignoreSubaccountIds?: number[]
} & Omit<DropdownButtonProps, 'children'>

const SubaccountsDropdown = ({
  subaccountId: selectedSubaccountId,
  onSelect,
  isSmOnly,
  ignoreSubaccountIds,
  label,
  ...buttonProps
}: Props) => {
  const { subaccountDatas } = useSubaccount()
  const selectedSubaccount: SubaccountData | undefined = subaccountDatas[selectedSubaccountId]

  return (
    <>
      <DropdownButton
        label={label ? label : selectedSubaccount ? selectedSubaccount.label : 'No Account'}
        isDisabled={!selectedSubaccount}
        icon={<ArrowLeftRight />}
        dropdownProps={{ minWidth: 350 }}
        {...buttonProps}
      >
        <SubaccountsDropdownItems
          ignoreSubaccountIds={ignoreSubaccountIds}
          isStandardMarginOnly={isSmOnly}
          subaccountId={selectedSubaccountId}
          onSelect={(subaccountId) => {
            onSelect(subaccountId)
          }}
        />
      </DropdownButton>
    </>
  )
}

export default SubaccountsDropdown
